module.exports = __webpack_public_path__ + "img/icon_map_1_5_yj_hg_c.c50cf861.png";